/**
 * defa.views.CustomerCollectionView
 * A view to list several Customers with.
 * @version 1.2.0
 */
import CustomerSnippet from 'scripts/defa/customers/view-customer-snippet';
import CollectionView  from 'scripts/poppet/collection-view';

const CustomerCollectionView = CollectionView.extend({
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
		
	childView: CustomerSnippet,
		
		
		
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
		
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
		
});
	
export default CustomerCollectionView